<template>
  <div class="onestop-set-meal" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="优选整包" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div>
      <div class="onestop-flow-path" >
        <div class="default-top-bg">
          <div class="title">整包流程</div>
        </div>
        <div class="flow-part general-box-shadow">
          <img class="icon-onestop-process" src="../../assets/onestop/icon-onestop-flow.png">
        </div>
      </div>
     <div class="sort">整包套餐</div>
      <div class="onestop-case-item general-box-shadow" v-for="(onestopCase) in onestopCaseList" >
        <img :src="imgUrl + onestopCase.cover" @click="openOnestopCaseDetail(onestopCase.id,onestopCase.title,onestopCase.price,onestopCase.companyId)">
        <div class="info-part">
          <div class="left-info" @click="openOnestopCaseDetail(onestopCase.id,onestopCase.title,onestopCase.price,onestopCase.companyId)">
            <span class="title">{{onestopCase.title}}</span>
            <span class="price">{{onestopCase.price}}元/㎡</span>
          </div>
          <div class="appointment-btn" @click="openOnestopReservation(onestopCase.id,onestopCase.title,onestopCase.price,onestopCase.companyId)">预 约</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {imgUrl,shareIcon} from '../../config'
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import OnestopProjectService from '../../service/onestop/OnestopProjectService'
  import shareService from '../../service/share/ShareService'

  export default {
    name: 'OnestopSetMeal',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        type:'1',
        onestopCaseList:[],
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getOnestopCaseList();
      this.initWechatShare();
    },
    methods: {
      openOnestopCaseDetail(id,caseTitle,casePrice,companyId){
        this.$router.push({name:'OnestopDetail',query:{id,caseTitle,casePrice,companyId}});
      },
      async openOnestopReservation(onestopCaseId,caseTitle,casePrice,companyId){
        if(!!this.global.isMiniProgrm ){
          wx.miniProgram.navigateTo({url: `/pages/onestop/book/book?onestopCaseId=${onestopCaseId}&caseTitle=${caseTitle}&casePrice=${casePrice}&companyId=${companyId}`});
        }else {
          this.$router.push({name:'OnestopReservation',query:{onestopCaseId,caseTitle,casePrice,companyId}});
        }
      },
      async initWechatShare(){
        let title = "水木家居商城超值套餐";// 分享标题
        let desc = "超高性价比的整包套餐，无论新房、二手房，总有一款适合你"; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      async getOnestopCaseList(){
        var result=await OnestopProjectService.getOnestopCaseList(this.type);
        if(result.code == 0){
          this.onestopCaseList = result.data;
          console.info('this.onestopCaseList',this.onestopCaseList)
        }else {
          Toast('获取整包方案信息失败');
        }
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  @import '../../assets/style/onestop-case.scss';
  .onestop-set-meal{
    background: white;
    font-size: 0.32rem;
    padding-bottom: 0.3rem;
    .sort{
      margin-top: 0.3rem;
      margin-left: 0.31rem;
      line-height: 0.46rem;
      font-size: 0.36rem;
      font-weight: bold;
    }
    .onestop-flow-path{
      .flow-part{
        width: 6.69rem;
        height: 2.75rem;
        margin: -0.7rem auto 0;
        border-radius: 0.08rem;
        background: white;
        text-align: center;
        .icon-onestop-process{
          width: 6.3rem;
          height: 2.15rem;
          margin-top: 0.32rem;
        }
      }
    }
  }
</style>
